(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jw-help-contact"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){if(e.target.closest('[data-open-notices]')){const n=document.getElementById('jw-help-notices');if(n)n.open=true}});

document.addEventListener('click',function(e){
  const button=e.target.closest('[data-jw-tidio-open]');
  if(!button)return;
  e.preventDefault();
  const feedback=document.querySelector('[data-jw-tidio-feedback]');
  let opened=false;
  function openChat(){
    const chat=window.tidioChatApi;
    if(!chat||typeof chat.open!=='function')return false;
    if(typeof chat.show==='function')chat.show();
    chat.open();
    opened=true;
    if(feedback)feedback.hidden=true;
    return true;
  }
  if(openChat())return;
  document.addEventListener('tidioChat-ready',openChat,{once:true});
  window.setTimeout(function(){if(!opened&&feedback)feedback.hidden=false;},6500);
});

  } catch(e) { console.error(e); }
})();
})();
